import { render, staticRenderFns } from "./CommentsUsersView.vue?vue&type=template&id=a22769b4&scoped=true&"
import script from "./CommentsUsersView.vue?vue&type=script&lang=ts&"
export * from "./CommentsUsersView.vue?vue&type=script&lang=ts&"
import style0 from "./CommentsUsersView.vue?vue&type=style&index=0&id=a22769b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a22769b4",
  null
  
)

export default component.exports